module.exports = __webpack_public_path__ + "4b9d16ae0cf413ed84a86cc47d13356d.png";